const minLength = 8;

export const accountNumberLengthValidator = (value) => {
  if (!value) {
    return true;
  } else {
    return value.replace(/[^0-9]/g, "").length >= minLength;
  }
}